import {
  DatagridConfigurable,
  TextField,
  DateField,
  NumberField,
  BooleanField,
  FunctionField,
  useListContext
} from 'react-admin';
import { useRowStyle } from '../../../../hooks/useRowStyle';
import { TotalRows } from '../../../helperComponents/TotalRows';
import { StatusChip } from '../ads_ingest_runs/components/StatusChip';
import { formatDate } from '../../../../helpers/googleAdsBridgesHelpers';
import {
  formatSchedule,
  formatWindow,
  formatCreated
} from '../../../../helpers/adsJobsHelpers';

export const AdsJobsDataGrid = () => {
  const rowClassName = useRowStyle();
  const { total } = useListContext();

  return (
    <>
      <TotalRows total={total} />
      <DatagridConfigurable
        rowClick="show"
        className={`${rowClassName} datagrid-content`}
        bulkActionButtons={false}
      >
        <TextField source="id" label="ID" />
        <TextField source="name" label="Name" />
        <TextField source="type" label="Type" />
        <TextField source="target" label="Target" sortable={false} />
        <TextField source="report" label="Report" sortable={false} />
        <FunctionField
          source="schedule"
          label="Schedule"
          render={(record) => formatSchedule(record)}
        />
        <FunctionField
          source="window_days"
          label="Window"
          sortable={false}
          render={(record) => formatWindow(record)}
        />
        <NumberField source="priority" label="Priority" />
        <BooleanField source="enabled" label="Enabled" />
        <FunctionField
          source="last_ok_at"
          label="Last OK"
          sortable={false}
          render={(record) => formatDate(record.last_ok_at)}
        />
        <FunctionField
          source="last_status"
          label="Last Status"
          sortable={false}
          render={(record) => <StatusChip status={record.last_status} />}
        />
        <DateField source="expires_at" label="Expires" />
        <FunctionField
          source="created_at"
          label="Created"
          render={(record) => formatCreated(record)}
        />
      </DatagridConfigurable>
    </>
  );
};
